import { Component, OnInit, Output, EventEmitter, inject, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import Swal from 'sweetalert2'
import { Global } from '@services/core/Global';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { UploadService } from '@services/core/upload.service';
import { CoreModule } from 'app/modules/core.module';
import ExcelJS from 'exceljs'
import { PanelComponent } from '@components/core-template/panel/panel.component';

import { FormsModule } from '@angular/forms';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { PayrollsService } from '@services/payrolls.service';

@Component({
  selector: 'app-insert-payrolls',
  standalone: true,
  imports: [PanelComponent, FormsModule, NgbNavModule],
  providers: [CoreModule, UploadService, PayrollsService],
  templateUrl: './insert.component.html',
  styleUrls: ['./insert.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InsertPayrollsComponent implements OnInit {
  @Output() selectedPayroll: EventEmitter<string> = new EventEmitter<string>()
  public titulo = 'Carga Masiva de Asegurados'
  private today = new Date()
  private currentMonth = this.today.getMonth() + 1
  protected tab = "ingreso"
  filesToUpload: any
  name_file: any
  public token;
  public Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true
  })

  protected month = this.today.getFullYear() + "-" + ((this.currentMonth < 10) ? "0" + this.currentMonth : this.currentMonth)
  protected policy: any
  protected listPayrolls = []

  private _payrollService = inject(PayrollsService)
  private cdr = inject(ChangeDetectorRef)

  constructor(
    private _uploadService: UploadService,
    private _authService: MicrosoftAuthService
  ) {
    this.token = _authService.getToken()
  }

  ngOnInit(): void {
    this.selectedPayroll.emit('')
  }

  fileChageEvent(fileInput: any) {
    this.filesToUpload = <Array<File>>fileInput.target.files;
    const xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    if (this.filesToUpload.length == 1 ) {
      this.name_file = fileInput.target.files[0].name;
    } else {
      this.Toast.fire({
        title: "Adjunte un Excel Válido (.xlsx)",
        icon: "info"
      })
    }

  }

  clearFile() {
    this.filesToUpload = null
    this.name_file = null
  }

  uploadPayloadFile() {
    if (this.name_file != null) {
      Swal.fire({
        text: "Procesando Archivo...",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      this.submitFile()
    } else {
      this.Toast.fire({
        title: "Adjunte un Archivo Valido (Excel)",
        icon: "info"
      })

    }
  }

  submitFile(){
    this._uploadService.makeFileRequest(Global.url_seguros + "upload-file/payrolls", [], this.filesToUpload, 'files', this.token).then((res: any) => {
      Swal.close()
      if (res.error) {
        Swal.fire({
          title: 'Error en linea: ' + (res.line || '0') + ', columna: ' + res.data,
          text: 'Valor obtenido: ' + res.value,
          icon: "warning"
        })
      } else {
        this.Toast.fire({
          title: res.msg,
          icon: "success"
        })
      }
      this.clearFileInput();
    })
  }

  clearFileInput() {
    // Restablece el valor del input file a null para limpiarlo
    const fileInput = document.getElementById('file') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
      this.name_file = null
    }
  }


}
